import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router } from "react-router-dom";
import { ConfigProvider } from 'antd';
import frFR from 'antd/locale/fr_FR';

const container = document.getElementById('root')!;
const root = createRoot(container);

root.render(
  <Router>
    <React.StrictMode>
      <ConfigProvider locale={frFR}>
        <App />
      </ConfigProvider>
    </React.StrictMode>
  </Router>
);

reportWebVitals();
